import { render, staticRenderFns } from "./childManagement.vue?vue&type=template&id=61ab097a&scoped=true"
import script from "./childManagement.vue?vue&type=script&lang=js"
export * from "./childManagement.vue?vue&type=script&lang=js"
import style0 from "./childManagement.vue?vue&type=style&index=0&id=61ab097a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab097a",
  null
  
)

export default component.exports